// src/bilesenler/Navbar.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async'; 

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSchoolToolsOpen, setIsSchoolToolsOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) {
      setIsDropdownOpen(false);
      setIsSchoolToolsOpen(false);
    }
  };

  const toggleInfo = () => setIsInfoVisible(!isInfoVisible);

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
    if (isSchoolToolsOpen) setIsSchoolToolsOpen(false);
  };

  const toggleSchoolTools = () => {
    setIsSchoolToolsOpen(!isSchoolToolsOpen);
    if (isSchoolToolsOpen) {
      setIsDropdownOpen(false);
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsSticky(scrollTop > 50);
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className={`header d-flex align-items-center ${isSticky ? 'sticky' : ''}`}>
        <nav className={`container bg-white custom-navbar ${isSticky ? 'sticky-nav' : ''}`}>
          {/* Mobil */}
          <div className="d-flex flex-column align-items-center d-lg-none w-100">
            <Link to="/" className={`navbar-brand ${isInfoVisible ? 'd-none' : ''}`}>
              <img src={`${process.env.PUBLIC_URL}/resimler/logo.svg`} alt="Hacı Ali Kara Logo" className={`navbar-logo ${isScrolled ? 'small-logo' : ''}`} />
            </Link>

            <div className={`social-links my-2 ${isScrolled ? 'small-icons' : ''}`}>
              <a href="https://www.instagram.com/fl.webtasarim" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram" /></a>
              <a href="https://x.com/hacialikara" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.205 2.25h3.545l-7.752 8.867L22.955 21h-7.133l-5.571-7.288L4.045 21H.5l8.211-9.387L0 2.25h7.333l5.028 6.654L18.205 2.25zm-1.141 17.366h1.977L6.917 4.384H4.84l12.224 15.232z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/hacialikara" target="_blank" rel="noopener noreferrer"><i className="bi bi-linkedin" /></a>
              <a href="https://github.com/hacialikara" target="_blank" rel="noopener noreferrer"><i className="bi bi-github" /></a>
              <a href="https://g.page/r/CR2ZdRP7eIj2EBM/review" target="_blank" rel="noopener noreferrer"><i className="bi bi-google" /></a>
            </div>

            {!isScrolled && (
              <div className="buttons mb-2">
                <button className="btn btn-primary me-2 info-toggle-btn" onClick={toggleInfo}>
                  <i className={`bi ${isInfoVisible ? 'bi-eye-slash' : 'bi-eye'}`}></i> <span>Kişisel Bilgilerim</span>
                </button>
              </div>
            )}
          </div>

          {/* Masaüstü */}
          <div className="d-none d-lg-flex w-100 align-items-center justify-content-between">
            <div className="buttons mb-2">
              <button className="btn btn-gradient me-2 info-toggle-btn" onClick={toggleInfo}>
                <i className={`bi ${isInfoVisible ? 'bi-eye-slash' : 'bi-eye'}`}></i> <span>Kişisel Bilgilerim</span>
              </button>
            </div>

            <Link to="/" className={`navbar-brand ${isInfoVisible ? 'd-none' : ''}`}>
              <img src={`${process.env.PUBLIC_URL}/resimler/logo.svg`} alt="Hacı Ali Kara Logo" className="navbar-logo" />
            </Link>

            <div className="social-links">
              <a href="https://www.instagram.com/fl.webtasarim" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram" /></a>
              <a href="https://x.com/hacialikara" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.205 2.25h3.545l-7.752 8.867L22.955 21h-7.133l-5.571-7.288L4.045 21H.5l8.211-9.387L0 2.25h7.333l5.028 6.654L18.205 2.25zm-1.141 17.366h1.977L6.917 4.384H4.84l12.224 15.232z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/hacialikara" target="_blank" rel="noopener noreferrer"><i className="bi bi-linkedin" /></a>
              <a href="https://github.com/hacialikara" target="_blank" rel="noopener noreferrer"><i className="bi bi-github" /></a>
              <a href="https://g.page/r/CR2ZdRP7eIj2EBM/review" target="_blank" rel="noopener noreferrer"><i className="bi bi-google" /></a>
            </div>
          </div>

          {/* Kişisel Bilgiler */}
          {isInfoVisible && (
            <div className="horizontal-info d-flex flex-column align-items-center w-100 my-2">
              <div className="card mb-3 card-horizontal">
                <img src={`${process.env.PUBLIC_URL}/resimler/profil.png`} className="card-img-top" alt="Hacı Ali Kara Profil" />
                <div className="card-body">
                  <h5 className="card-title">Hacı Ali Kara</h5>
                  <p className="card-text"><strong>Email:</strong> hacialikara@outlook.com</p>
                  <p className="card-text"><strong>Telefon:</strong> +90 (505) 106 41 15</p>
                  <p className="card-text"><strong>Doğum Günü:</strong> 06 Nisan 1994</p>
                  <p className="card-text"><strong>Milliyet:</strong>
                    <img src={`${process.env.PUBLIC_URL}/resimler/flags/Flag_of_Turkey.svg.webp`} alt="Türkiye Bayrağı" className="flag-icon" />
                    <img src={`${process.env.PUBLIC_URL}/resimler/flags/Flag_of_Romania.svg.png`} alt="Romanya Bayrağı" className="flag-icon" />
                    <img src={`${process.env.PUBLIC_URL}/resimler/flags/Flag-European-Union.webp`} alt="Avrupa Birliği Bayrağı" className="flag-icon" />
                  </p>
                  <p className="card-text"><strong>Konum:</strong> Yeşilova, Kocaeli, Türkiye</p>
                </div>
              </div>
            </div>
          )}
        </nav>

        {/* 1. Hamburger Menü */}
        <button className="hamburger-menu" type="button" onClick={toggleMenu}>
          <i className="bi bi-menu-down hamburger-icon"></i>
        </button>

        {/* 2. Okul Araçları Menü Butonu */}
        <button className="school-tools-menu" type="button" onClick={toggleSchoolTools}>
          <i className="bi bi-backpack3 hamburger-icon"></i>
        </button>

        {/* 3. YENİ EKLENEN: Poketop Butonu (Classroom Tool Linki) */}
       {/* Poketop Butonu */}
<Link 
    to="/classroomtool" 
    className="pokeball-menu" 
    title="Güneş Puanlama Sistemi"
>
    <img 
        src="https://upload.wikimedia.org/wikipedia/commons/5/53/Pok%C3%A9_Ball_icon.svg" 
        alt="Pokeball" 
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
    />
</Link>

        {/* Tam Ekran Ana Menü */}
        <div className={`fullscreen-menu ${isMenuOpen ? 'open' : ''}`}>
          <button className="menu-close-btn" onClick={toggleMenu}>
            <i className="bi bi-x-lg"></i>
          </button>
          <div className="menu-content">
            <ul className="navbar-nav">
              <li className="nav-item"><Link to="/" className="nav-link" onClick={toggleMenu}><i className="bi bi-house-door-fill me-2"></i> Anasayfa</Link></li>
              <li className="nav-item"><Link to="/egitimim" className="nav-link" onClick={toggleMenu}><i className="bi bi-journal-bookmark-fill me-2"></i> Eğitim Bilgilerim</Link></li>
              <li className="nav-item"><Link to="/portfolyom" className="nav-link" onClick={toggleMenu}><i className="bi bi-file-earmark-text-fill me-2"></i> Web Portfolyom</Link></li>
              <li className="nav-item"><Link to="/kampanya" className="nav-link" onClick={toggleMenu}><i className="bi bi-file-earmark-text-fill me-2"></i> Web Sitesi Kampanyası</Link></li>
              <li className="nav-item"><Link to="/tasarimlarim" className="nav-link" onClick={toggleMenu}><i className="bi bi-palette me-2"></i> Afiş Tasarımlarım</Link></li>
              
              {/* Paket Programlar Dropdown */}
              <li className="nav-item">
                <button
                  className="nav-link dropdown-toggle"
                  onClick={toggleDropdown}
                  type="button"
                  aria-expanded={isDropdownOpen}
                  aria-haspopup="true"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    textAlign: 'center'
                  }}
                >
                  <i className="bi bi-box-seam me-2"></i> Paket Programlar
                </button>
                <ul className={`dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
                  <li>
                    <Link
                      to="/neoncanvas"
                      className="dropdown-item"
                      onClick={() => {
                        toggleMenu();
                        setIsDropdownOpen(false);
                      }}
                    >
                      <i className="bi bi-lightning-charge me-2"></i> Kendi Neon Ürününü Oluştur
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/mugcanvas"
                      className="dropdown-item"
                      onClick={() => {
                        toggleMenu();
                        setIsDropdownOpen(false);
                      }}
                    >
                      <i className="bi bi-lightning-charge me-2"></i> Kendi 3D Bardak Tasarımın
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/kupabardak"
                      className="dropdown-item"
                      onClick={() => {
                        toggleMenu();
                        setIsDropdownOpen(false);
                      }}
                    >
                      <i className="bi bi-lightning-charge me-2"></i> Kendi 3D Kupa Bardak Tasarımın
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/ledsigndesigner"
                      className="dropdown-item"
                      onClick={() => {
                        toggleMenu();
                        setIsDropdownOpen(false);
                      }}
                    >
                      <i className="bi bi-lightning-charge me-2"></i> Kendi Led Tablo Tasarımını Oluştur
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/takvim"
                      className="dropdown-item"
                      onClick={() => {
                        toggleMenu();
                        setIsDropdownOpen(false);
                      }}
                    >
                      <i className="bi bi-lightning-charge me-2"></i> Freelance Çalışma Takvimi
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/gundemler"
                      className="dropdown-item"
                      onClick={() => {
                        toggleMenu();
                        setIsDropdownOpen(false);
                      }}
                    >
                      <i className="bi bi-lightning-charge me-2"></i> Gündemler Yazılımı
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/yemeklistesi"
                      className="dropdown-item"
                      onClick={() => {
                        toggleMenu();
                        setIsDropdownOpen(false);
                      }}
                    >
                      <i className="bi bi-lightning-charge me-2"></i> Aylık Yemek Listesi
                    </Link>
                  </li>
                </ul>
              </li>
              
              <li className="nav-item"><Link to="/blog" className="nav-link" onClick={toggleMenu}><i className="bi bi-pencil-square me-2"></i> Blog Yazılarım</Link></li>
              <li className="nav-item"><Link to="/iletisim" className="nav-link" onClick={toggleMenu}><i className="bi bi-envelope-fill me-2"></i> İletişim</Link></li>
            </ul>
          </div>
        </div>

       {/* Tam Ekran Okul Araçları Menüsü */}
       <div className={`fullscreen-menu ${isSchoolToolsOpen ? 'open' : ''}`}>
          <button className="menu-close-btn" onClick={toggleSchoolTools}>
            <i className="bi bi-x-lg"></i>
          </button>
          <div className="menu-content">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  to="/spinwheel"
                  className="nav-link"
                  onClick={() => {
                    toggleSchoolTools();
                  }}
                >
                  <i className="bi bi-shuffle me-2"></i> Rastgele İsim ve Sayı Çarkı
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/timer"
                  className="nav-link"
                  onClick={() => {
                    toggleSchoolTools();
                  }}
                >
                  <i className="bi bi-clock me-2"></i> Zamanlayıcı
                </Link>
              </li>
               <li className="nav-item">
                <Link
                  to="/classroomtool"
                  className="nav-link"
                  onClick={() => {
                    toggleSchoolTools();
                  }}
                >
                  <i className="bi bi-star-fill me-2"></i> Güneş Öğrenci Puanlama Sistemi
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/videolar"
                  className="nav-link"
                  onClick={() => {
                    toggleSchoolTools();
                  }}
                >
                  <i className="bi bi-clock me-2"></i> Eğitimsel Videolar
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/kisayollar"
                  className="nav-link"
                  onClick={() => {
                    toggleSchoolTools();
                  }}
                >
                  <i className="bi bi-copy"></i> Geliştiriciler için Kısayollar
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="https://gunemon.hacialikara.com"
                  className="nav-link"
                  onClick={() => {
                    toggleSchoolTools();
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-star-fill me-2"></i> Gunemon Puanlama Sistemi (Yeni)
                </Link>
              </li>
              {/* --- YENİ EKLENEN HATIRLATICI LİNKİ --- */}
              <li className="nav-item">
                <Link
                  to="/hatirlatici"
                  className="nav-link"
                  onClick={() => {
                    toggleSchoolTools();
                  }}
                >
                  <i className="bi bi-bell-fill me-2"></i> Canlı Hatırlatıcı
                </Link>
              </li>
              {/* -------------------------------------- */}
            </ul>
          </div>
        </div>
        
        {/* WhatsApp */}
        <a href="https://wa.me/905051064115" className="whatsapp-icon" target="_blank" rel="noopener noreferrer">
          <i className="bi bi-whatsapp"></i>
        </a>
      </header>
    </>
  );
};

export default Navbar;